/**
 * GENERATED CODE
 * this file is generated by the 'process-icons' script.
 */
import React from 'react';
import { createSvgIcon } from '../utils';
export default createSvgIcon(React.createElement("g", { style: { transform: 'scaleY(-1)', transformOrigin: '50% 50%' } },
    React.createElement("path", { d: "M358.2 407.12c4.24023 0.160156 8.08008 -2.32031 9.71973 -6.24023c1.63965 -3.87988 0.759766 -8.36035 -2.28027 -11.3203l-197.56 -197.56l197.56 -197.56c2.68066 -2.56055 3.76074 -6.40039 2.80078 -9.95996\rc-0.920898 -3.60059 -3.7207 -6.40039 -7.32031 -7.32031c-3.56055 -0.959961 -7.40039 0.120117 -9.95996 2.7998l-204.8 204.8c-4 4 -4 10.4805 0 14.4805l204.8 204.8c1.83984 1.91992 4.35938 3.04004 7.04004 3.08008z" })), 'Back', '0.00195312 64 512 512');
//# sourceMappingURL=BackIcon.js.map